import type { IconName } from '@/components/entities/Sprite/Icon';
import type { ModalNameType } from '@/modals/components/ModalProvider';
import { isFairPlayEnabled } from '@/app/[locale]/(root)/fair-play/availability';
import { AppRoutes } from '@/i18n/constants';

export type NavigationLink = {
  label: string;
  icon: IconName;
  href?: string;
  modal?: ModalNameType;
  badge?: string;
  /** Keeps the link active on nested routes, e.g. every `/fair-play/*` page for the Fair Play dashboard link. */
  activePathPrefix?: string;
};

const FAIR_PLAY_LINK: NavigationLink = {
  label: 'Fair Play',
  icon: 'fairplay',
  href: `${AppRoutes.fairPlay}/dashboard`,
  activePathPrefix: AppRoutes.fairPlay,
  badge: 'Beta',
};

const GAMIFICATION_LINKS: NavigationLink[] = [
  {
    label: 'Missions',
    icon: 'missions',
    href: AppRoutes.gamificationMissions,
  },
  {
    label: 'Rewards',
    icon: 'rewards',
    href: AppRoutes.gamificationRewards,
  },
];

export const PROTECTED_LINKS: NavigationLink[] = [
  {
    label: 'Shop',
    icon: 'purchases',
    modal: 'deposit',
  },
  {
    label: 'Redeem',
    icon: 'redeem',
    modal: 'redeem',
  },
  ...(GAMIFICATION_LINKS),
  {
    label: 'Promotions',
    modal: 'deposit',
    icon: 'promotion',
  },
  ...(isFairPlayEnabled() ? [FAIR_PLAY_LINK] : []),
];

export const ACCOUNT_LINKS: NavigationLink[] = [

  {
    label: 'Profile',
    href: '/profile',
    icon: 'profile',
  },

  {
    label: 'Customer Support',
    modal: 'support',
    icon: 'support-navbar',
  },
];
